/* eslint-disable react/prop-types */
import React, { memo, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";
import DatePicker from "react-flatpickr";
import SoftDatePicker from "components/SoftDatePicker";
import { item } from "examples/Sidenav/styles/sidenavItem";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
  fontSize: "14px",
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    id: 1,
    shtk: "111",
    shtkBold: true,
    tentk: "Tiền mặt",
    tentkBold: true,
    readOnly: true,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 2,
    shtk: "1111",
    shtkBold: false,
    tentk: "Tiền Việt Nam",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 3,
    shtk: "1112",
    shtkBold: false,
    tentk: "Ngoại tệ",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 4,
    shtk: "112",
    shtkBold: true,
    tentk: "Tiền gửi ngân hàng",
    tentkBold: true,
    readOnly: true,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 5,
    shtk: "1121",
    shtkBold: false,
    tentk: "Tiền Việt Nam",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 6,
    shtk: "1122",
    shtkBold: false,
    tentk: "Ngoại tệ",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 7,
    shtk: "121",
    shtkBold: true,
    tentk: "Chứng khoán kinh doanh",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 8,
    shtk: "128",
    shtkBold: true,
    tentk: "Đầu tư nắm giữ đến ngày đáo hạn",
    tentkBold: true,
    readOnly: true,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 9,
    shtk: "1281",
    shtkBold: false,
    tentk: "Tiền gửi có kỳ hạn",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 10,
    shtk: "1288",
    shtkBold: false,
    tentk: "Các khoản đầu tư khác nắm giữ đến ngày đáo hạn",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 11,
    shtk: "131",
    shtkBold: true,
    tentk: "Phải thu của khách hàng",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  // {
  //   id: 12,
  //   shtk: "132",
  //   shtkBold: true,
  //   tentk: "Phải thu của hoạt động tín dụng nội bộ",
  //   tentkBold: true,
  //   readOnly: true,
  //   valueBold: true,
  //   value: {
  //     sddk: {
  //       no: { disable: false, value: 0 },
  //       co: { disable: false, value: 0 },
  //     },
  //     spstk: {
  //       no: { disable: false, value: 0 },
  //       co: { disable: false, value: 0 },
  //     },
  //     sdck: {
  //       no: { disable: false, value: 0 },
  //       co: { disable: false, value: 0 },
  //     },
  //   },
  // },
  // {
  //   id: 13,
  //   shtk: "1321",
  //   shtkBold: false,
  //   tentk: "Phải thu hoạt động cho vay",
  //   tentkBold: false,
  //   readOnly: true,
  //   valueBold: false,
  //   value: {
  //     sddk: {
  //       no: { disable: false, value: 0 },
  //       co: { disable: false, value: 0 },
  //     },
  //     spstk: {
  //       no: { disable: false, value: 0 },
  //       co: { disable: false, value: 0 },
  //     },
  //     sdck: {
  //       no: { disable: false, value: 0 },
  //       co: { disable: false, value: 0 },
  //     },
  //   },
  // },
  // {
  //   id: 14,
  //   shtk: "13211",
  //   shtkBold: false,
  //   tentk: "Phải thu về gốc cho vay",
  //   tentkBold: false,
  //   readOnly: false,
  //   valueBold: false,
  //   value: {
  //     sddk: {
  //       no: { disable: false, value: 0 },
  //       co: { disable: false, value: 0 },
  //     },
  //     spstk: {
  //       no: { disable: false, value: 0 },
  //       co: { disable: false, value: 0 },
  //     },
  //     sdck: {
  //       no: { disable: false, value: 0 },
  //       co: { disable: false, value: 0 },
  //     },
  //   },
  // },
  // {
  //   id: 15,
  //   shtk: "13212",
  //   shtkBold: false,
  //   tentk: "Phải thu về lãi cho vay",
  //   tentkBold: false,
  //   readOnly: false,
  //   valueBold: false,
  //   value: {
  //     sddk: {
  //       no: { disable: false, value: 0 },
  //       co: { disable: false, value: 0 },
  //     },
  //     spstk: {
  //       no: { disable: false, value: 0 },
  //       co: { disable: false, value: 0 },
  //     },
  //     sdck: {
  //       no: { disable: false, value: 0 },
  //       co: { disable: false, value: 0 },
  //     },
  //   },
  // },
  // {
  //   id: 16,
  //   shtk: "1322",
  //   shtkBold: false,
  //   tentk: "Phải thu hoạt động tín dụng nội bộ khác",
  //   tentkBold: false,
  //   readOnly: false,
  //   valueBold: false,
  //   value: {
  //     sddk: {
  //       no: { disable: false, value: 0 },
  //       co: { disable: false, value: 0 },
  //     },
  //     spstk: {
  //       no: { disable: false, value: 0 },
  //       co: { disable: false, value: 0 },
  //     },
  //     sdck: {
  //       no: { disable: false, value: 0 },
  //       co: { disable: false, value: 0 },
  //     },
  //   },
  // },
  {
    id: 17,
    shtk: "133",
    shtkBold: true,
    tentk: "Thuế GTGT được khấu trừ",
    tentkBold: true,
    readOnly: true,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 18,
    shtk: "1331",
    shtkBold: false,
    tentk: "Thuế GTGT được khấu trừ của hàng hóa, dịch vụ",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 19,
    shtk: "1332",
    shtkBold: false,
    tentk: "Thuế GTGT được khấu trừ của TSCĐ",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 20,
    shtk: "136",
    shtkBold: true,
    tentk: "Phải thu nội bộ",
    tentkBold: true,
    readOnly: true,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 21,
    shtk: "1361",
    shtkBold: false,
    tentk: "Vốn kinh doanh ở đơn vị trực thuộc",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 22,
    shtk: "1368",
    shtkBold: false,
    tentk: "Phải thu nội bộ khác",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 23,
    shtk: "138",
    shtkBold: true,
    tentk: "Phải thu khác",
    tentkBold: true,
    readOnly: true,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 24,
    shtk: "1381",
    shtkBold: false,
    tentk: "Tài sản thiếu chờ xử lý",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 25,
    shtk: "1386",
    shtkBold: false,
    tentk: "Cầm cố, thế chấp, ký quỹ, ký cược",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 26,
    shtk: "1388",
    shtkBold: false,
    tentk: "Phải thu khác",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 27,
    shtk: "141",
    shtkBold: true,
    tentk: "Tạm ứng",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 28,
    shtk: "151",
    shtkBold: true,
    tentk: "Hàng mua đang đi đường",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 29,
    shtk: "152",
    shtkBold: true,
    tentk: "Nguyên liệu, vật liệu",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 30,
    shtk: "153",
    shtkBold: true,
    tentk: "Công cụ, dụng cụ",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 31,
    shtk: "154",
    shtkBold: true,
    tentk: "Chi phí sản xuất, kinh doanh dở dang",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 32,
    shtk: "155",
    shtkBold: true,
    tentk: "Thành phẩm",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 33,
    shtk: "156",
    shtkBold: true,
    tentk: "Hàng hóa",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 34,
    shtk: "157",
    shtkBold: true,
    tentk: "Hàng gửi đi bán",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 35,
    shtk: "211",
    shtkBold: true,
    tentk: "Tài sản cố định",
    tentkBold: true,
    readOnly: true,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 36,
    shtk: "2111",
    shtkBold: false,
    tentk: "TSCĐ hữu hình",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 37,
    shtk: "2112",
    shtkBold: false,
    tentk: "TSCĐ thuê tài chính",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 38,
    shtk: "2113",
    shtkBold: false,
    tentk: "TSCĐ vô hình",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 39,
    shtk: "214",
    shtkBold: true,
    tentk: "Hao mòn tài sản cố định",
    tentkBold: true,
    readOnly: true,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 40,
    shtk: "2141",
    shtkBold: false,
    tentk: "Hao mòn TSCĐ hữu hình",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 41,
    shtk: "2142",
    shtkBold: false,
    tentk: "Hao mòn TSCĐ thuê tài chính",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 42,
    shtk: "2143",
    shtkBold: false,
    tentk: "Hao mòn TSCĐ vô hình",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 43,
    shtk: "2147",
    shtkBold: false,
    tentk: "Hao mòn bất động sản đầu tư",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 44,
    shtk: "217",
    shtkBold: true,
    tentk: "Bất động sản đầu tư",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 45,
    shtk: "228",
    shtkBold: true,
    tentk: "Đầu tư góp vốn vào đơn vị khác",
    tentkBold: true,
    readOnly: true,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 46,
    shtk: "2281",
    shtkBold: false,
    tentk: "Đầu tư vào công ty liên doanh, liên kết",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 47,
    shtk: "2288",
    shtkBold: false,
    tentk: "Đầu tư khác",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 48,
    shtk: "229",
    shtkBold: true,
    tentk: "Dự phòng tổn thất tài sản",
    tentkBold: true,
    readOnly: true,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 49,
    shtk: "2291",
    shtkBold: false,
    tentk: "Dự phòng giảm giá chứng khoán kinh doanh",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 50,
    shtk: "2292",
    shtkBold: false,
    tentk: "Dự phòng tổn thất đầu tư vào đơn vị khác",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 51,
    shtk: "2293",
    shtkBold: false,
    tentk: "Dự phòng phải thu khó đòi",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 52,
    shtk: "2294",
    shtkBold: false,
    tentk: "Dự phòng giảm giá hàng tồn kho",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 53,
    shtk: "241",
    shtkBold: true,
    tentk: "Xây dựng cơ bản dở dang",
    tentkBold: true,
    readOnly: true,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 54,
    shtk: "2411",
    shtkBold: false,
    tentk: "Mua sắm TSCĐ",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 55,
    shtk: "2412",
    shtkBold: false,
    tentk: "Xây dựng cơ bản",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 56,
    shtk: "2413",
    shtkBold: false,
    tentk: "Sửa chữa lớn TSCĐ",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 57,
    shtk: "242",
    shtkBold: true,
    tentk: "Chi phí trả trước",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 58,
    shtk: "",
    shtkBold: true,
    tentk: "LOẠI TÀI KHOẢN NỢ PHẢI TRẢ",
    tentkCenter: true,
    tentkBold: true,
    readOnly: true,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: "" },
        co: { disable: false, value: "" },
      },
      spstk: {
        no: { disable: false, value: "" },
        co: { disable: false, value: "" },
      },
      sdck: {
        no: { disable: false, value: "" },
        co: { disable: false, value: "" },
      },
    },
  },
  {
    id: 59,
    shtk: "331",
    shtkBold: true,
    tentk: "Phải trả cho người bán",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  // {
  //   id: 60,
  //   shtk: "332",
  //   shtkBold: true,
  //   tentk: "Phải trả của hoạt động tín dụng nội bộ",
  //   tentkBold: true,
  //   readOnly: true,
  //   valueBold: true,
  //   value: {
  //     sddk: {
  //       no: { disable: false, value: 0 },
  //       co: { disable: false, value: 0 },
  //     },
  //     spstk: {
  //       no: { disable: false, value: 0 },
  //       co: { disable: false, value: 0 },
  //     },
  //     sdck: {
  //       no: { disable: false, value: 0 },
  //       co: { disable: false, value: 0 },
  //     },
  //   },
  // },
  // {
  //   id: 61,
  //   shtk: "3321",
  //   shtkBold: false,
  //   tentk: "Phải trả từ hoạt động đi vay của thành viên",
  //   tentkBold: false,
  //   readOnly: true,
  //   valueBold: false,
  //   value: {
  //     sddk: {
  //       no: { disable: false, value: 0 },
  //       co: { disable: false, value: 0 },
  //     },
  //     spstk: {
  //       no: { disable: false, value: 0 },
  //       co: { disable: false, value: 0 },
  //     },
  //     sdck: {
  //       no: { disable: false, value: 0 },
  //       co: { disable: false, value: 0 },
  //     },
  //   },
  // },
  // {
  //   id: 62,
  //   shtk: "33211",
  //   shtkBold: false,
  //   tentk: "Phải trả về gốc vay",
  //   tentkBold: false,
  //   readOnly: false,
  //   valueBold: false,
  //   value: {
  //     sddk: {
  //       no: { disable: false, value: 0 },
  //       co: { disable: false, value: 0 },
  //     },
  //     spstk: {
  //       no: { disable: false, value: 0 },
  //       co: { disable: false, value: 0 },
  //     },
  //     sdck: {
  //       no: { disable: false, value: 0 },
  //       co: { disable: false, value: 0 },
  //     },
  //   },
  // },
  // {
  //   id: 63,
  //   shtk: "33212",
  //   shtkBold: false,
  //   tentk: "Phải trả về lãi vay",
  //   tentkBold: false,
  //   readOnly: false,
  //   valueBold: false,
  //   value: {
  //     sddk: {
  //       no: { disable: false, value: 0 },
  //       co: { disable: false, value: 0 },
  //     },
  //     spstk: {
  //       no: { disable: false, value: 0 },
  //       co: { disable: false, value: 0 },
  //     },
  //     sdck: {
  //       no: { disable: false, value: 0 },
  //       co: { disable: false, value: 0 },
  //     },
  //   },
  // },
  // {
  //   id: 64,
  //   shtk: "3322",
  //   shtkBold: false,
  //   tentk: "Phải trả hoạt động tín dụng nội bộ khác",
  //   tentkBold: false,
  //   readOnly: false,
  //   valueBold: false,
  //   value: {
  //     sddk: {
  //       no: { disable: false, value: 0 },
  //       co: { disable: false, value: 0 },
  //     },
  //     spstk: {
  //       no: { disable: false, value: 0 },
  //       co: { disable: false, value: 0 },
  //     },
  //     sdck: {
  //       no: { disable: false, value: 0 },
  //       co: { disable: false, value: 0 },
  //     },
  //   },
  // },
  {
    id: 65,
    shtk: "333",
    shtkBold: true,
    tentk: "Thuế và các khoản phải nộp Nhà nước",
    tentkBold: true,
    readOnly: true,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 66,
    shtk: "3331",
    shtkBold: false,
    tentk: "Thuế giá trị gia tăng phải nộp",
    tentkBold: false,
    readOnly: true,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 67,
    shtk: "33311",
    shtkBold: false,
    tentk: "Thuế GTGT đầu ra",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 68,
    shtk: "33312",
    shtkBold: false,
    tentk: "Thuế GTGT hàng nhập khẩu",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 69,
    shtk: "3332",
    shtkBold: false,
    tentk: "Thuế tiêu thụ đặc biệt",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 70,
    shtk: "3333",
    shtkBold: false,
    tentk: "Thuế xuất, nhập khẩu",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 71,
    shtk: "3334",
    shtkBold: false,
    tentk: "Thuế thu nhập doanh nghiệp",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 72,
    shtk: "3335",
    shtkBold: false,
    tentk: "Thuế thu nhập cá nhân",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 73,
    shtk: "3336",
    shtkBold: false,
    tentk: "Thuế tài nguyên",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 74,
    shtk: "3337",
    shtkBold: false,
    tentk: "Thuế nhà đất, tiền thuê đất",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 75,
    shtk: "3338",
    shtkBold: false,
    tentk: "Thuế bảo vệ môi trường và các loại thuế khác",
    tentkBold: false,
    readOnly: true,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 76,
    shtk: "33381",
    shtkBold: false,
    tentk: "Thuế bảo vệ môi trường",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 77,
    shtk: "33382",
    shtkBold: false,
    tentk: "Các loại thuế khác",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 78,
    shtk: "3339",
    shtkBold: false,
    tentk: "Phí, lệ phí và các khoản phải nộp khác",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 79,
    shtk: "334",
    shtkBold: true,
    tentk: "Phải trả người lao động",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 80,
    shtk: "335",
    shtkBold: true,
    tentk: "Chi phí phải trả",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 81,
    shtk: "336",
    shtkBold: true,
    tentk: "Phải trả nội bộ",
    tentkBold: true,
    readOnly: true,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 82,
    shtk: "3361",
    shtkBold: false,
    tentk: "Phải trả nội bộ về vốn kinh doanh",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 83,
    shtk: "3368",
    shtkBold: false,
    tentk: "Phải trả nội bộ khác",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 84,
    shtk: "338",
    shtkBold: true,
    tentk: "Phải trả, phải nộp khác",
    tentkBold: true,
    readOnly: true,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 85,
    shtk: "3381",
    shtkBold: false,
    tentk: "Tài sản thừa chờ giải quyết",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 86,
    shtk: "3382",
    shtkBold: false,
    tentk: "Kinh phí công đoàn",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 87,
    shtk: "3383",
    shtkBold: false,
    tentk: "Bảo hiểm xã hội",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 88,
    shtk: "3384",
    shtkBold: false,
    tentk: "Bảo hiểm y tế",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 89,
    shtk: "3385",
    shtkBold: false,
    tentk: "Bảo hiểm thất nghiệp",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 90,
    shtk: "3386",
    shtkBold: false,
    tentk: "Nhận ký quỹ, ký cược",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 91,
    shtk: "3387",
    shtkBold: false,
    tentk: "Doanh thu chưa thực hiện",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 92,
    shtk: "3388",
    shtkBold: false,
    tentk: "Phải trả, phải nộp khác",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 93,
    shtk: "341",
    shtkBold: true,
    tentk: "Vay và nợ thuê tài chính",
    tentkBold: true,
    readOnly: true,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 94,
    shtk: "3411",
    shtkBold: false,
    tentk: "Các khoản đi vay",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 95,
    shtk: "3412",
    shtkBold: false,
    tentk: "Nợ thuê tài chính",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  // {
  //   id: 96,
  //   shtk: "342",
  //   shtkBold: true,
  //   tentk: "Khoản trợ cấp, hõ trợ của Nhà nước phải hoàn lại",
  //   tentkBold: true,
  //   readOnly: false,
  //   valueBold: true,
  //   value: {
  //     sddk: {
  //       no: { disable: false, value: 0 },
  //       co: { disable: false, value: 0 },
  //     },
  //     spstk: {
  //       no: { disable: false, value: 0 },
  //       co: { disable: false, value: 0 },
  //     },
  //     sdck: {
  //       no: { disable: false, value: 0 },
  //       co: { disable: false, value: 0 },
  //     },
  //   },
  // },
  {
    id: 97,
    shtk: "352",
    shtkBold: true,
    tentk: "Dự phòng phải trả",
    tentkBold: true,
    readOnly: true,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 98,
    shtk: "3521",
    shtkBold: false,
    tentk: "Dự phòng bảo hành sản phẩm hàng hóa",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 99,
    shtk: "3522",
    shtkBold: false,
    tentk: "Dự phòng bảo hành công trình xây dựng",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 100,
    shtk: "3524",
    shtkBold: false,
    tentk: "Dự phòng phải trả khác",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 101,
    shtk: "353",
    shtkBold: true,
    tentk: "Quỹ khen thưởng phúc lợi",
    tentkBold: true,
    readOnly: true,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 102,
    shtk: "3531",
    shtkBold: false,
    tentk: "Quỹ khen thưởng",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 103,
    shtk: "3532",
    shtkBold: false,
    tentk: "Quỹ phúc lợi",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 104,
    shtk: "3533",
    shtkBold: false,
    tentk: "Quỹ phúc lợi đã hình thành TSCĐ",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 105,
    shtk: "3534",
    shtkBold: false,
    tentk: "Quỹ thưởng ban quản lý điều hành công ty",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 106,
    shtk: "356",
    shtkBold: true,
    tentk: "Quỹ phát triển khoa học và công nghệ",
    tentkBold: true,
    readOnly: true,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 107,
    shtk: "3561",
    shtkBold: false,
    tentk: "Quỹ phát triển khoa học và công nghệ",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 108,
    shtk: "3562",
    shtkBold: false,
    tentk: "Quỹ phát triển khoa học và công nghệ đã hình thành TSCĐ",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  // {
  //   id: 109,
  //   shtk: "359",
  //   shtkBold: true,
  //   tentk: "Quỹ dự phòng rủi ro tín dụng",
  //   tentkBold: true,
  //   readOnly: false,
  //   valueBold: true,
  //   value: {
  //     sddk: {
  //       no: { disable: false, value: 0 },
  //       co: { disable: false, value: 0 },
  //     },
  //     spstk: {
  //       no: { disable: false, value: 0 },
  //       co: { disable: false, value: 0 },
  //     },
  //     sdck: {
  //       no: { disable: false, value: 0 },
  //       co: { disable: false, value: 0 },
  //     },
  //   },
  // },
  {
    id: 110,
    shtk: "",
    shtkBold: true,
    tentk: "LOẠI TÀI KHOẢN VỐN CHỦ SỞ HỮU",
    tentkCenter: true,
    tentkBold: true,
    readOnly: true,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: "" },
        co: { disable: false, value: "" },
      },
      spstk: {
        no: { disable: false, value: "" },
        co: { disable: false, value: "" },
      },
      sdck: {
        no: { disable: false, value: "" },
        co: { disable: false, value: "" },
      },
    },
  },
  {
    id: 111,
    shtk: "411",
    shtkBold: true,
    tentk: "Vốn đầu tư của chủ sở hữu",
    tentkBold: true,
    readOnly: true,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 112,
    shtk: "4111",
    shtkBold: false,
    tentk: "Vốn góp của chủ sở hữu",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 113,
    shtk: "4112",
    shtkBold: false,
    tentk: "Thặng dư vốn cổ phần",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 114,
    shtk: "4118",
    shtkBold: false,
    tentk: "Vốn khác",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 115,
    shtk: "413",
    shtkBold: true,
    tentk: "Chênh lệch tỷ giá hối đoái",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 116,
    shtk: "418",
    shtkBold: true,
    tentk: "Các quỹ thuộc vốn chủ sở hữu",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 117,
    shtk: "419",
    shtkBold: true,
    tentk: "Cỗ phiếu quỹ",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 118,
    shtk: "421",
    shtkBold: true,
    tentk: "Lợi nhuận sau thuế chưa phân phối",
    tentkBold: true,
    readOnly: true,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 119,
    shtk: "4211",
    shtkBold: false,
    tentk: "Lợi nhuận sau thuế chưa phân phối năm trước",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 120,
    shtk: "4212",
    shtkBold: false,
    tentk: "Lợi nhuận sau thuế chưa phân phối năm nay",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  // {
  //   id: 121,
  //   shtk: "442",
  //   shtkBold: true,
  //   tentk: "Nguồn vốn trợ cấp, hỗ trợ không hoàn lại của Nhà nước",
  //   tentkBold: true,
  //   readOnly: false,
  //   valueBold: true,
  //   value: {
  //     sddk: {
  //       no: { disable: false, value: 0 },
  //       co: { disable: false, value: 0 },
  //     },
  //     spstk: {
  //       no: { disable: false, value: 0 },
  //       co: { disable: false, value: 0 },
  //     },
  //     sdck: {
  //       no: { disable: false, value: 0 },
  //       co: { disable: false, value: 0 },
  //     },
  //   },
  // },
  {
    id: 122,
    shtk: "",
    shtkBold: true,
    tentk: "LOẠI TÀI KHOẢN DOANH THU",
    tentkCenter: true,
    tentkBold: true,
    readOnly: true,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: "" },
        co: { disable: false, value: "" },
      },
      spstk: {
        no: { disable: false, value: "" },
        co: { disable: false, value: "" },
      },
      sdck: {
        no: { disable: false, value: "" },
        co: { disable: false, value: "" },
      },
    },
  },
  {
    id: 123,
    shtk: "511",
    shtkBold: true,
    tentk: "Doanh thu bán hàng và cung cấp dịch vụ",
    tentkBold: true,
    readOnly: true,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 124,
    shtk: "5111",
    shtkBold: false,
    tentk: "Doanh thu bán hàng hóa",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 125,
    shtk: "5112",
    shtkBold: false,
    tentk: "Doanh thu bán thành phẩm",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 126,
    shtk: "5113",
    shtkBold: false,
    tentk: "Doanh thu cung cấp dịch vụ",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 127,
    shtk: "5118",
    shtkBold: false,
    tentk: "Doanh thu khác",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 128,
    shtk: "515",
    shtkBold: true,
    tentk: "Doanh thu hoạt động tài chính",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  // {
  //   id: 129,
  //   shtk: "546",
  //   shtkBold: true,
  //   tentk: "Doanh thu hoạt động tín dụng nội bộ",
  //   tentkBold: true,
  //   readOnly: false,
  //   valueBold: true,
  //   value: {
  //     sddk: {
  //       no: { disable: false, value: 0 },
  //       co: { disable: false, value: 0 },
  //     },
  //     spstk: {
  //       no: { disable: false, value: 0 },
  //       co: { disable: false, value: 0 },
  //     },
  //     sdck: {
  //       no: { disable: false, value: 0 },
  //       co: { disable: false, value: 0 },
  //     },
  //   },
  // },
  {
    id: 130,
    shtk: "",
    shtkBold: true,
    tentk: "LOẠI TÀI KHOẢN CHI PHÍ SẢN XUẤT, KINH DOANH",
    tentkCenter: true,
    tentkBold: true,
    readOnly: true,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: "" },
        co: { disable: false, value: "" },
      },
      spstk: {
        no: { disable: false, value: "" },
        co: { disable: false, value: "" },
      },
      sdck: {
        no: { disable: false, value: "" },
        co: { disable: false, value: "" },
      },
    },
  },
  {
    id: 131,
    shtk: "611",
    shtkBold: true,
    tentk: "Mua hàng",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 132,
    shtk: "631",
    shtkBold: true,
    tentk: "Giá thành sản xuất",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 133,
    shtk: "632",
    shtkBold: true,
    tentk: "Giá vốn hàng bán",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 134,
    shtk: "635",
    shtkBold: true,
    tentk: "Chi phí tài chính",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 135,
    shtk: "642",
    shtkBold: true,
    tentk: "Chi phí quản lý kinh doanh",
    tentkBold: true,
    readOnly: true,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 136,
    shtk: "6421",
    shtkBold: false,
    tentk: "Chi phí bán hàng",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 137,
    shtk: "6422",
    shtkBold: false,
    tentk: "Chi phí quản lý doanh nghiệp",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  // {
  //   id: 138,
  //   shtk: "646",
  //   shtkBold: true,
  //   tentk: "Chi phí hoạt động tín dụng nội bộ",
  //   tentkBold: true,
  //   readOnly: false,
  //   valueBold: true,
  //   value: {
  //     sddk: {
  //       no: { disable: false, value: 0 },
  //       co: { disable: false, value: 0 },
  //     },
  //     spstk: {
  //       no: { disable: false, value: 0 },
  //       co: { disable: false, value: 0 },
  //     },
  //     sdck: {
  //       no: { disable: false, value: 0 },
  //       co: { disable: false, value: 0 },
  //     },
  //   },
  // },
  {
    id: 139,
    shtk: "",
    shtkBold: true,
    tentk: "LOẠI TÀI KHOẢN THU NHẬP KHÁC",
    tentkCenter: true,
    tentkBold: true,
    readOnly: true,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: "" },
        co: { disable: false, value: "" },
      },
      spstk: {
        no: { disable: false, value: "" },
        co: { disable: false, value: "" },
      },
      sdck: {
        no: { disable: false, value: "" },
        co: { disable: false, value: "" },
      },
    },
  },
  {
    id: 140,
    shtk: "711",
    shtkBold: true,
    tentk: "Thu nhập khác",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 141,
    shtk: "",
    shtkBold: true,
    tentk: "LOẠI TÀI KHOẢN CHI PHÍ KHÁC",
    tentkCenter: true,
    tentkBold: true,
    readOnly: true,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: "" },
        co: { disable: false, value: "" },
      },
      spstk: {
        no: { disable: false, value: "" },
        co: { disable: false, value: "" },
      },
      sdck: {
        no: { disable: false, value: "" },
        co: { disable: false, value: "" },
      },
    },
  },
  {
    id: 142,
    shtk: "811",
    shtkBold: true,
    tentk: "Chi phí khác",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 143,
    shtk: "821",
    shtkBold: true,
    tentk: "Chi phí thuế thu nhập doanh nghiệp",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 144,
    shtk: "",
    shtkBold: true,
    tentk: "TÀI KHOẢN XÁC ĐỊNH KẾT QUẢ KINH DOANH",
    tentkCenter: true,
    tentkBold: true,
    readOnly: true,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: "" },
        co: { disable: false, value: "" },
      },
      spstk: {
        no: { disable: false, value: "" },
        co: { disable: false, value: "" },
      },
      sdck: {
        no: { disable: false, value: "" },
        co: { disable: false, value: "" },
      },
    },
  },
  {
    id: 145,
    shtk: "911",
    shtkBold: true,
    tentk: "Xác định kết quả kinh doanh",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 146,
    shtk: "",
    shtkBold: true,
    tentk: "Tổng cộng",
    tentkBold: true,
    readOnly: true,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
];
function Table5({ setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values.e;
    const type = values.type;
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          if (name === "sdck") {
            if (type === "no") {
              item.value.sdck.no.value = value;
            }
            if (type === "co") {
              item.value.sdck.co.value = value;
            }
          }
          if (name === "sddk") {
            if (type === "no") {
              item.value.sddk.no.value = value;
            }
            if (type === "co") {
              item.value.sddk.co.value = value;
            }
          }
          if (name === "spstk") {
            if (type === "no") {
              item.value.spstk.no.value = value;
            }
            if (type === "co") {
              item.value.spstk.co.value = value;
            }
          }
        }
        return item;
      })
    );
    // console.log(data);
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <thead>
            <tr>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Số hiệu tài khoản</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Tên tài khoản</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} colSpan={2}>
                Số dư đầu kỳ
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} colSpan={2}>
                Số phát sinh trong kỳ
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} colSpan={2}>
                Số dư cuối kỳ
              </Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center" }}></Th>
              <Th style={{ textAlign: "center" }}></Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Nợ</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Có</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Nợ</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Có</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Nợ</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Có</Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>A</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>B</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>1</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>2</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>3</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>4</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>5</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>6</Th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.length > 0 &&
              data.map((rows) => (
                <tr key={rows.id}>
                  <Td
                    style={{
                      textAlign: "center",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.shtkBold === true ? "bold" : 400,
                    }}
                  >
                    {rows.shtk}
                  </Td>
                  <Td
                    style={{
                      textAlign: rows.tentkCenter && rows.tentkCenter === true ? "center" : "left",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.tentkBold === true ? "bold" : 400,
                    }}
                  >
                    {rows.tentk}
                  </Td>
                  {/* -- */}
                  <Td
                    colSpan={1}
                    style={{
                      textAlign: "right",
                      background:
                        rows.readOnly === true
                          ? rows.value.sddk.no.disable === true
                            ? "#DCDCDC"
                            : "#ddeff3"
                          : rows.value.sddk.no.disable === true
                          ? "#DCDCDC"
                          : "transparent",
                      fontWeight: rows.readOnly === true ? "bold" : 400,
                    }}
                  >
                    <InputTable
                      id={rows.id}
                      name="sddk"
                      readOnly={rows.value.sddk.no.disable === true ? true : rows.readOnly}
                      value={rows.value.sddk.no.value}
                      onChange={(e) => handleChange({ e, type: "no" })}
                      fontWeight={rows.valueBold}
                    />
                  </Td>
                  <Td
                    colSpan={1}
                    style={{
                      textAlign: "right",
                      background:
                        rows.readOnly === true
                          ? rows.value.sddk.co.disable === true
                            ? "#DCDCDC"
                            : "#ddeff3"
                          : rows.value.sddk.co.disable === true
                          ? "#DCDCDC"
                          : "transparent",
                      fontWeight: rows.readOnly === true ? "bold" : 400,
                    }}
                  >
                    <InputTable
                      id={rows.id}
                      name="sddk"
                      title="co"
                      readOnly={rows.value.sddk.co.disable === true ? true : rows.readOnly}
                      value={rows.value.sddk.co.value}
                      onChange={(e) => handleChange({ e, type: "co" })}
                      fontWeight={rows.valueBold}
                    />
                  </Td>
                  {/* -- */}
                  <Td
                    colSpan={1}
                    style={{
                      textAlign: "right",
                      background:
                        rows.readOnly === true
                          ? rows.value.spstk.no.disable === true
                            ? "#DCDCDC"
                            : "#ddeff3"
                          : rows.value.spstk.no.disable === true
                          ? "#DCDCDC"
                          : "transparent",
                      fontWeight: rows.readOnly === true ? "bold" : 400,
                    }}
                  >
                    <InputTable
                      id={rows.id}
                      name="spstk"
                      readOnly={rows.value.spstk.no.disable === true ? true : rows.readOnly}
                      value={rows.value.spstk.no.value}
                      onChange={(e) => handleChange({ e, type: "no" })}
                      fontWeight={rows.valueBold}
                    />
                  </Td>
                  <Td
                    colSpan={1}
                    style={{
                      textAlign: "right",
                      background:
                        rows.readOnly === true
                          ? rows.value.spstk.co.disable === true
                            ? "#DCDCDC"
                            : "#ddeff3"
                          : rows.value.spstk.co.disable === true
                          ? "#DCDCDC"
                          : "transparent",
                      fontWeight: rows.readOnly === true ? "bold" : 400,
                    }}
                  >
                    <InputTable
                      id={rows.id}
                      name="spstk"
                      title="co"
                      readOnly={rows.value.spstk.co.disable === true ? true : rows.readOnly}
                      value={rows.value.spstk.co.value}
                      onChange={(e) => handleChange({ e, type: "co" })}
                      fontWeight={rows.valueBold}
                    />
                  </Td>
                  {/* -- */}
                  <Td
                    colSpan={1}
                    style={{
                      textAlign: "right",
                      background:
                        rows.readOnly === true
                          ? rows.value.sdck.no.disable === true
                            ? "#DCDCDC"
                            : "#ddeff3"
                          : rows.value.sdck.no.disable === true
                          ? "#DCDCDC"
                          : "transparent",
                      fontWeight: rows.readOnly === true ? "bold" : 400,
                    }}
                  >
                    <InputTable
                      id={rows.id}
                      name="sdck"
                      readOnly={rows.value.sdck.no.disable === true ? true : rows.readOnly}
                      value={rows.value.sdck.no.value}
                      onChange={(e) => handleChange({ e, type: "no" })}
                      fontWeight={rows.valueBold}
                    />
                  </Td>
                  <Td
                    colSpan={1}
                    style={{
                      textAlign: "right",
                      background:
                        rows.readOnly === true
                          ? rows.value.sdck.co.disable === true
                            ? "#DCDCDC"
                            : "#ddeff3"
                          : rows.value.sdck.co.disable === true
                          ? "#DCDCDC"
                          : "transparent",
                      fontWeight: rows.readOnly === true ? "bold" : 400,
                    }}
                  >
                    <InputTable
                      id={rows.id}
                      name="sdck"
                      title="co"
                      readOnly={rows.value.sdck.co.disable === true ? true : rows.readOnly}
                      value={rows.value.sdck.co.value}
                      onChange={(e) => handleChange({ e, type: "co" })}
                      fontWeight={rows.valueBold}
                    />
                  </Td>
                  {/* -- */}
                </tr>
              ))}
          </tbody>
        </table>
      </Box>
    </Box>
  );
}

export default memo(Table5);

function InputTable(props) {
  const { id, onChange, fontWeight, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ id, value: newValue !== "" ? +newValue : "", name });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: "14px",
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
        fontWeight: fontWeight && fontWeight === true ? "bold" : 400,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}

function InputTable2(props) {
  const { id, onChange, type, fontWeight, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  const regexDecimal = /^(0|0?\.\d*|1|1(\.0*)?)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value;
    if (type == "number") {
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name });
    } else if (type == "decimal") {
      if (!regexDecimal.test(newValue)) return;
      onChange({ id, value: newValue, name });
    } else {
      onChange({ id, value: newValue !== "" ? newValue : "", name });
    }
  }
  return (
    <input
      type={type == "date" ? "date" : ""}
      style={{
        textAlign: "center",
        fontSize: "14px",
        color: "#344767",
        border: "none",
        width: type == "date" ? "150px" : "100%",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        fontWeight: fontWeight === true ? "bold" : 400,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
